import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';
import { PAPER_SHEEN, OBA, PAPER_WEIGHT, PAPER_TEXTURE } from '../../../config';
const PaperGroupList = props => {
  const [paperGroups, setPaperGroups] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
      ellipsis: true,
    },
    {
      title: 'Paper Family',
      dataIndex: 'paper_family',
      key: 'paper_family',
      sorter: true,
      ellipsis: true,
      render: family => {
        return <>{family?.name}</>;
      },
      ...filter('paper_family'),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ellipsis: true,
      ...filter('name'),
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      sorter: true,
      ellipsis: true,
      ...filter('code'),
    },
    {
      title: 'Ba/Sr ratio average',
      dataIndex: 'ba_sr_ratio_average',
      key: 'ba_sr_ratio_average',
      ellipsis: true,
      sorter: true,
      ...filter('ba_sr_ratio_average'),
    },
    {
      title: 'Ba/Sr ratio low limit',
      dataIndex: 'ba_sr_ratio_low_limit',
      key: 'ba_sr_ratio_low_limit',
      sorter: true,
      ellipsis: true,
      ...filter('ba_sr_ratio_low_limit'),
    },
    {
      title: 'Ba/Sr ratio high limit',
      dataIndex: 'ba_sr_ratio_high_limit',
      key: 'ba_sr_ratio_high_limit',
      sorter: true,
      ellipsis: true,
      ...filter('ba_sr_ratio_high_limit'),
    },
    {
      title: 'Optical Brightener',
      dataIndex: 'optical_brightener',
      key: 'optical_brightener',
      sorter: true,
      ellipsis: true,
      render: oba => {
        const matchedItem = OBA.find(item => item.key == oba);
        return matchedItem ? <>{matchedItem.value}</> : null;
      },
    },
    {
      title: 'Paper Sheen',
      dataIndex: 'paper_sheen',
      key: 'paper_sheen',
      sorter: true,
      ellipsis: true,
      render: text => {
        const matchedItem = PAPER_SHEEN.find(item => item.key == text);
        return matchedItem ? <>{matchedItem.value}</> : null;
      },
    },
    {
      title: 'Paper Weight',
      dataIndex: 'paper_weight',
      key: 'paper_weight',
      sorter: true,
      ellipsis: true,
      render: text => {
        const matchedItem = PAPER_WEIGHT.find(item => item.key == text);
        return matchedItem ? <>{matchedItem.value}</> : null;
      },
    },
    {
      title: 'Actions',
      key: 'action',
      fixed: 'right',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/paper-groups/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_paper_groups?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_paper_groups?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'paper_groups',
              'Paper Group?',
              paperGroups,
              setPaperGroups,
              props?.tabs_permissions?.settings_paper_groups?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getPaperGroupsData(pagination);
  })();
  }, []);

  const getPaperGroupsData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('paper_groups', {
        fields: [
          'id,name,paper_family.name,code,ba_sr_ratio_average,ba_sr_ratio_low_limit,ba_sr_ratio_high_limit',
          'optical_brightener,paper_sheen,paper_weight',
        ],
        sort: sorter?.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setPaperGroups(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  // const handleTableChange = async (pagination, filters, sorter) => {
  //   setPagination(pagination);
  //   setSorter(sorter);
  //   setLoading(true);
  //   const numericFieldsArray = [
  //     'ba_absolute_low',
  //     'ba_absolute_high',
  //     'sr_absolute_low',
  //     'sr_absolute_high',
  //     'ba_sr_ratio_average',
  //     'ba_sr_ratio_low_limit',
  //     'ba_sr_ratio_high_limit',
  //   ];

  //   let filtersitems = {};
  //   for (let key in filters) {
  //     if (filters.hasOwnProperty(key)) {
  //       let val = filters[key];
  //       if (val) {
  //         if(numericFieldsArray.includes(key)){
  //           { _eq: val[0] }
  //         }
  //         filtersitems[key] = key === 'paper_family' ? { name: { _icontains: val[0] } } : { _icontains: val[0] };
  //       }
  //     }
  //   }
  //   await getPaperGroupsData(pagination, filtersitems, sorter);
  // };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);

    const numericFieldsArray = [
      'ba_absolute_low',
      'ba_absolute_high',
      'sr_absolute_low',
      'sr_absolute_high',
      'ba_sr_ratio_average',
      'ba_sr_ratio_low_limit',
      'ba_sr_ratio_high_limit',
    ];

    let filtersitems = {};

    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (numericFieldsArray.includes(key) && val) {
          filtersitems[key] = { _eq: val[0] };
        } else if (val) {
          filtersitems[key] = key === 'paper_family' ? { name: { _icontains: val[0] } } : { _icontains: val[0] };
        }
      }
    }

    await getPaperGroupsData(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/paper-groups" }, { title: "Paper Groups" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Paper Groups
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_paper_groups,
                `/settings/paper-groups/new`,
                'Create Paper Group'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={paperGroups}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PaperGroupList;
